export default class {
    constructor(Box) {
        /* Constants */
        this.LAYOUT_BUTTONS = 'buttons';    // Show only buttons
        this.LAYOUT_PRICE   = 'price';      // Show the Price Layout and buttons

        this.Box = Box;
        this.layout = this.LAYOUT_BUTTONS;  // Shows buttons as standard
        this.readButtonsFromComponent();
    }

    readButtonsFromComponent() {
        let buttons = this.Box.read('buttons').split(',');

        // I case it has "price", we prepare a different layout
        let hasPrice   = buttons.indexOf('price');
        if (hasPrice !== -1) {
            this.layout = this.LAYOUT_PRICE;
            buttons.splice(hasPrice, 1);
        }

        this.items = buttons;
    }

    get() {
        return this.items;
    }

    getLayout() {
        return this.layout;
    }

    hasPriceLayout() {
        return this.getLayout() === this.LAYOUT_PRICE;
    }

    hasInformationButton() {
        return this.get().includes('information');
    }
}
